export * from '@fhs/routing/src/routes/(tabs)/menu/_layout';
export { default } from '@fhs/routing/src/routes/(tabs)/menu/_layout';
